import {json,postBiz,rows} from '../core/coreapi';

import {
  AllocationMode,
  IAllocationActivity,
  IAllocationBudgetControl,
  IAllocationCostCenter,
  IAllocationLineItem,
  IAllocationLink,
  IAllocationSummary,
  IActivityBudgetRegisterResult,
} from './budgetallocation.models';

import {
  normalizeActivityBudgetControl,
  normalizeAllocationActivity,
  normalizeAllocationCostCenter,
  normalizeAllocationLineItem,
  normalizeAllocationLink,
  normalizeAllocationSummary,
  normalizeActivityBudgetHeader,
  normalizeActivityBudgetRegister,
} from './budgetallocation.normalizers';

export const fetchActivityBudgetWorkbench = async (
  planningcycleid: number,
): Promise<any> => {
  const response = await postBiz({
    s: 'activitybudget',
    a: 'workbench',
    pci: planningcycleid,
  });

  const workbench = json(response) ?? {};
  return {
    ...workbench,
    control: normalizeActivityBudgetControl(workbench.control ?? {}),
  };
};

// export const fetchActivityBudgetWorkbench = async (
//   planningcycleid: number,
// ) => {
//   const response = await yourExistingRequestHelper({
//     s: 'activitybudget',
//     a: 'workbench',
//     pci: planningcycleid,
//   });

//   if (response.rc !== 0) {
//     throw new Error(
//       response.em ||
//       response.sm ||
//       'Unable to load Activity Budget workbench.',
//     );
//   }

//   return response.sd;
// };

export const fetchActivityBudgetRegister=async(
  planningcycleid:number,
  costcenterid?:number|null,
):Promise<IActivityBudgetRegisterResult>=>{
  const response=await postBiz({
    s:'activitybudget',
    a:'register',
    pci:planningcycleid,
    cci:costcenterid??null,
  });

  const data=json(response)??{};

  return {
    rows:Array.isArray(data?.rows)
      ?data.rows.map(normalizeActivityBudgetRegister)
      :[],
    summary:normalizeAllocationSummary(data?.summary??{}),
    header:normalizeActivityBudgetHeader(data?.header??{}),
    filter:data?.filter??{costcenterid:costcenterid??null},
  };
};

export const fetchCostCenters=async(
  planningcycleid:number,
  budgetplanid?:string|number|null,
):Promise<IAllocationCostCenter[]>=>
  rows(
    await postBiz({
      s:'activitybudget',
      a:'costcenters',
      pci:planningcycleid,
      bpi:budgetplanid||null,
    }),
  ).map(normalizeAllocationCostCenter);

export const fetchActivities=async(
  planningcycleid:number,
  costcenterid:number,
  search='',
  budgetplanid?:string|number|null,
):Promise<IAllocationActivity[]>=>
  rows(
    await postBiz({
      s:'activitybudget',
      a:'activities',
      pci:planningcycleid,
      cci:costcenterid,
      qry:search||null,
      bpi:budgetplanid||null,
    }),
  ).map(normalizeAllocationActivity);

export const fetchLineItems=async(
  planningcycleid:number,
  costcenterid:number,
  search='',
  budgetplanid?:string|number|null,
):Promise<IAllocationLineItem[]>=>
  rows(
    await postBiz({
      s:'activitybudget',
      a:'lineitems',
      pci:planningcycleid,
      cci:costcenterid,
      qry:search||null,
      six:true,
      bpi:budgetplanid||null,
    }),
  ).map(normalizeAllocationLineItem);

export const fetchLinks=async(
  planningcycleid:number,
  costcenterid:number,
  budgetplanid?:string|number|null,
):Promise<IAllocationLink[]>=>
  rows(
    await postBiz({
      s:'activitybudget',
      a:'links',
      pci:planningcycleid,
      cci:costcenterid,
      bpi:budgetplanid||null,
    }),
  ).map(normalizeAllocationLink);

export const fetchSummary=async(
  planningcycleid:number,
  costcenterid:number,
  budgetplanid?:string|number|null,
):Promise<IAllocationSummary>=>
  normalizeAllocationSummary(
    json(
      await postBiz({
        s:'activitybudget',
        a:'summary',
        pci:planningcycleid,
        cci:costcenterid,
        bpi:budgetplanid||null,
      }),
    ),
  );

export const processAllocation=async(payload:{
  planningcycleid:number;
  costcenterid:string|number;
  budgetplanid?:string|number|null;
  activityplanids:Array<string|number>;
  lineitemids:Array<string|number>;
  mode:AllocationMode;
  totalamount?:number;
})=>json(
  await postBiz({
    s:'activitybudget',
    a:'allocate',

    pci:payload.planningcycleid,
    cci:payload.costcenterid,
    bpi:payload.budgetplanid||null,

    aps:payload.activityplanids,
    lis:payload.lineitemids,

    mod:payload.mode,
    tot:Number(payload.totalamount||0),
  }),
);

export const unmapLinks=async(
  planningcycleid:number,
  linkids:Array<string|number>,
)=>json(
  await postBiz({
    s:'activitybudget',
    a:'unmap',
    pci:planningcycleid,
    lis:linkids,
  }),
);
export const transitionActivityBudget=async(payload:{
  planningcycleid:number;
  action:'SUBMIT'|'REOPEN';
  reason?:string|null;
  stamp:string;
})=>json(
  await postBiz({
    s:'activitybudget',
    a:'transition',
    pci:payload.planningcycleid,
    act:payload.action,
    rsn:payload.reason||null,
    stp:payload.stamp,
  }),
);
